import React from "react";
import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface Props {
	refId: string;
}

const NoLoanAccess = ({ refId }: Props) => {
	const { t } = useTranslation("admin");

	return (
		<div>
			<div className={"content-header"}>
				<h1>{t("modules.loan.header.title")}</h1>
			</div>
			<div className={"content-preview"}>
				<Alert variant={"danger"}>
					{t("modules.loan.field.no_access_to_loan.title")} "{refId}"
				</Alert>
			</div>
		</div>
	);
};

export default NoLoanAccess;
